
<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-table">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white">{{ $t('nav.projects') }}</h1>
                              <p class="lead  text-white">{{ $t('about.title') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">{{ $t('about.title4') }}</h2>
                        <p class="lead text-muted">{{ $t('about.paraProjects') }}</p>
                    </div>
                </div>
                <div v-for="projectGroup in groupedProjects" v-bind:key="projectGroup.id"
                    class="row row-grid">
                    <div  v-for="project in projectGroup" v-bind:key="project.id"
                        class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                          <a :href="'/project/'+project.slug">
                            <img v-lazy="project.src"
                                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">{{ project.title }}</span>
                                    <small class="h6 text-muted">{{ project.role }}</small>
                                </h5>
                            </div>
                          </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import projectsData from '../data/projects.js';

export default {
  name: "projects",
  components: {},
  data() {
    return {
      projects: projectsData,
    }
  },
  computed: {
    groupedProjects() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < this.projects.length; i++) {
        if (i % 4 == 0) { 
          index++;
          grouped[index] = [];
        }
        grouped[index].push(this.projects[i]);
      }
      return grouped;
    }
  }
};
</script>